import { render, staticRenderFns } from "./GoldSchemeEnlisting.vue?vue&type=template&id=4722ad0a&"
import script from "./GoldSchemeEnlisting.vue?vue&type=script&lang=js&"
export * from "./GoldSchemeEnlisting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports